export const columns = [
  // { field: 'id', headerName: 'S.No', minWidth: 60,width:60,headerAlign: 'center',align:'center',headerClassName: 'super-app-theme--header',renderCell: (params) => (
  //   <div style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
  //     {params.value}
  //   </div>
  // )},
  { field: 'college_code', headerName: 'College Code',minWidth: 82,width:82,headerAlign: 'center',align:'center',headerClassName: 'super-app-theme--header',renderCell: (params) => (
    <div style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
      {params.value}
    </div>
  )},
  { field: 'college_name', headerName: 'College Name', minWidth: 350,width:280,headerAlign: 'center',headerClassName: 'super-app-theme--header',renderCell: (params) => (
    <div style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
      {params.value}
    </div>
  ) },
  { field: 'branch_code', headerName: 'Branch Code', minWidth: 60,width:60,headerAlign: 'center',align:'center',headerClassName: 'super-app-theme--header',renderCell: (params) => (
    <div style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
      {params.value}
    </div>
  ) },
  { field: 'branch_name', headerName: 'Branch Name', minWidth: 190,width:190,headerAlign: 'center',headerClassName: 'super-app-theme--header' ,renderCell: (params) => (
    <div style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
      {params.value}
    </div>
  )},
  { field: 'y2025_OC_cutoff', headerName: 'OC Cutoff', minWidth: 60 ,width:60,headerClassName: 'center-header',headerAlign: 'center',align:'center',headerClassName: 'super-app-theme--header',renderCell: (params) => (
    <div style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
      {params.value}
    </div>
  )},
  { field: 'y2025_OC_rank', headerName: 'OC Rank', minWidth: 70,width:70,headerAlign: 'center',align:'center',headerClassName: 'super-app-theme--header',renderCell: (params) => (
    <div style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
      {params.value}
    </div>
  ) },
  { field: 'y2025_BC_cutoff', headerName: 'BC Cutoff', minWidth: 60,width:60,headerAlign: 'center',align:'center',headerClassName: 'super-app-theme--header',renderCell: (params) => (
    <div style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
      {params.value}
    </div>
  ) },
  { field: 'y2025_BC_rank', headerName: 'BC Rank', minWidth: 70,width:70,headerAlign: 'center',align:'center',headerClassName: 'super-app-theme--header',renderCell: (params) => (
    <div style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
      {params.value}
    </div>
  ) },
  { field: 'y2025_BCM_cutoff', headerName: 'BCM Cutoff', minWidth: 60,width:60,headerAlign: 'center',align:'center',headerClassName: 'super-app-theme--header',renderCell: (params) => (
    <div style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
      {params.value}
    </div>
  ) },
  { field: 'y2025_BCM_rank', headerName: 'BCM Rank', minWidth: 70,width:70,headerAlign: 'center',align:'center',headerClassName: 'super-app-theme--header',renderCell: (params) => (
    <div style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
      {params.value}
    </div>
  )},
  { field: 'y2025_MBC_cutoff', headerName: 'MBC Cutoff', minWidth: 60,width:60,headerAlign: 'center',align:'center',headerClassName: 'super-app-theme--header',renderCell: (params) => (
    <div style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
      {params.value}
    </div>
  ) },
  { field: 'y2025_MBC_rank', headerName: 'MBC Rank', minWidth: 70,width:70,headerAlign: 'center',align:'center',headerClassName: 'super-app-theme--header',renderCell: (params) => (
    <div style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
      {params.value}
    </div>
  ) },
  { field: 'y2025_SC_cutoff', headerName: 'SC Cutoff', minWidth: 60 ,width:60,headerAlign: 'center',align:'center',headerClassName: 'super-app-theme--header',renderCell: (params) => (
    <div style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
      {params.value}
    </div>
  )},
  { field: 'y2025_SC_rank', headerName: 'SC Rank', minWidth: 70 ,width:70,headerAlign: 'center',align:'center',headerClassName: 'super-app-theme--header',renderCell: (params) => (
    <div style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
      {params.value}
    </div>
  )},
  { field: 'y2025_SCA_cutoff', headerName: 'SCA Cutoff', minWidth: 60,width:60,headerAlign: 'center',align:'center',headerClassName: 'super-app-theme--header',renderCell: (params) => (
    <div style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
      {params.value}
    </div>
  ) },
  { field: 'y2025_SCA_rank', headerName: 'SCA Rank', minWidth: 70,width:70,headerAlign: 'center',align:'center',headerClassName: 'super-app-theme--header',renderCell: (params) => (
    <div style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
      {params.value}
    </div>
  ) },
  { field: 'y2025_ST_cutoff', headerName: 'ST Cutoff', minWidth: 60 ,width:60,headerAlign: 'center',align:'center',headerClassName: 'super-app-theme--header',renderCell: (params) => (
    <div style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
      {params.value}
    </div>
  )},
  { field: 'y2025_ST_rank', headerName: 'ST Rank', minWidth: 67 ,width:67,headerAlign: 'center',align:'center',headerClassName: 'super-app-theme--header',renderCell: (params) => (
    <div style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
      {params.value}
    </div>
  )},
  { field: 'y2025_MBCDNC_cutoff', headerName: 'MBCDNC Cutoff', minWidth: 80,width:80,headerAlign: 'center' ,align:'center',headerClassName: 'super-app-theme--header',renderCell: (params) => (
    <div style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
      {params.value}
    </div>
  )},
  { field: 'y2025_MBCDNC_rank', headerName: 'MBCDNC Rank', minWidth: 80 ,width:80,headerAlign: 'center',align:'center',headerClassName: 'super-app-theme--header',renderCell: (params) => (
    <div style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
      {params.value}
    </div>
  )},
  { field: 'y2025_MBCV_cutoff', headerName: 'MBCV Cutoff', minWidth: 80 ,width:80,headerAlign: 'center',align:'center',headerClassName: 'super-app-theme--header',renderCell: (params) => (
    <div style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
      {params.value}
    </div>
  )},
  { field: 'y2025_MBCV_rank', headerName: 'MBCV Rank', minWidth: 70 ,width:70,headerAlign: 'center',align:'center',headerClassName: 'super-app-theme--header',renderCell: (params) => (
    <div style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
      {params.value}
    </div>
  )}
];

export const disablecolumns =[
  { field: 'id', headerName: 'S.No', minWidth: 60,width:60,headerAlign: 'center',align:'center',headerClassName: 'super-app-theme--header',renderCell: (params) => (
    <div style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
      {params.value}
    </div>
  )},
  { field: 'college_code', headerName: 'College Code',minWidth: 82,width:82,headerAlign: 'center',align:'center',headerClassName: 'super-app-theme--header',renderCell: (params) => (
    <div style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
      {params.value}
    </div>
  )},
  { field: 'college_name', headerName: 'College Name', minWidth: 280,width:280,headerAlign: 'center',headerClassName: 'super-app-theme--header',renderCell: (params) => (
    <div style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
      {params.value}
    </div>
  ) },
  { field: 'branch_code', headerName: 'Branch Code', minWidth: 60,width:60,headerAlign: 'center',align:'center',headerClassName: 'super-app-theme--header',renderCell: (params) => (
    <div style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
      {params.value}
    </div>
  ) },
  { field: 'branch_name', headerName: 'Branch Name', minWidth: 190,width:190,headerAlign: 'center',headerClassName: 'super-app-theme--header' ,renderCell: (params) => (
    <div style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
      {params.value}
    </div>
  )},
];
